import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  accountsPayable: {
    description: "Header label for 'Accounts Payable'",
    defaultMessage: 'Accounts Payable'
  },
  onDemand: {
    description: "Header label for 'On-Demand'",
    defaultMessage: 'On-Demand'
  },
  paymentRegister: {
    description: "Header label for 'Payment Register'",
    defaultMessage: 'Register'
  },
  paymentsHeader: {
    description: 'Header prefix',
    defaultMessage: 'Payments: {workflow}'
  },
  invoicesSelected: {
    description: 'Message for number of vendorInvoices selected',
    defaultMessage: 'Invoices Selected'
  },
  singleInvoiceSelected: {
    description: 'Message for number of vendorInvoices selected',
    defaultMessage: 'Invoice Selected'
  },
  paymentCanceled: {
    description: 'Success message for payment canceled',
    defaultMessage:
      'The invoice has been returned to the Needs Authorization tab'
  },
  paymentsCanceled: {
    description: 'Success message for payments canceled',
    defaultMessage:
      'The invoices have been returned to the Needs Authorization tab'
  },
  paymentDeclined: {
    description: 'Success message for payment declined',
    defaultMessage: 'The invoice has been returned to the To Be Paid tab'
  },
  paymentsDeclined: {
    description: 'Success message for payments declined',
    defaultMessage: 'The invoices have been returned to the To Be Paid tab'
  }
});

export const labels = defineMessages({
  tableTitle: {
    defaultMessage: 'Vendors',
    description: 'Vendors table title'
  },
  schedule: {
    defaultMessage: 'Schedule',
    description: "Tab label for 'AP Schedule'"
  },
  toBePaid: {
    defaultMessage: 'To Be Paid',
    description: "Tab label for 'To Be Paid'"
  },
  needsAuthorization: {
    defaultMessage: 'Needs Authorization',
    description: "Tab label for 'Needs Authorization'"
  },
  printChecks: {
    defaultMessage: 'Print Checks',
    description: "Tab label for 'Print Checks'"
  },
  reconcileCreditCards: {
    defaultMessage: 'Reconcile Credit Cards',
    description: "Tab label for 'Reconcile Credit Cards'"
  },
  yes: {
    defaultMessage: 'yes',
    description: 'Cell contents for hold column'
  },
  needsAuthorizationTitle: {
    defaultMessage: 'Export/Archive - Needs Authorization',
    description: 'Title for export/archive dialog'
  },
  needsAuthorizationTableHeaderTitle: {
    defaultMessage: 'Needs Authorization Report',
    description: 'Needs authorization table header title in export to pdf page'
  },
  toBePaidTableHeaderTitle: {
    defaultMessage: 'To Be Paid Report',
    description: 'To be paid table header title in export to pdf page'
  }
});

export const columnHeaders = defineMessages({
  vendorName: {
    defaultMessage: 'Vendor Name',
    description: 'Vendor name column header'
  },
  paymentMethod: {
    defaultMessage: 'Payment Method',
    description: 'Payment method setup for the vendor in vendor management'
  },
  amount: {
    defaultMessage: 'Amount ($)',
    description: 'Amount ($) due in invoices for the vendor'
  },
  discountAmount: {
    defaultMessage: 'Discount ($)',
    description: 'Discount ($) applicable to the vendor'
  },
  netPayment: {
    defaultMessage: 'Net Payment ($)',
    description: 'Net Payment column header'
  },
  invoiceId: {
    defaultMessage: 'Invoice No.',
    description: 'Invoice No. column header'
  },
  invoiceDate: {
    defaultMessage: 'Invoice Date',
    description: 'Invoice Date column header'
  },
  dueDate: {
    defaultMessage: 'Due Date',
    description: 'Due Date column header'
  },
  hold: {
    defaultMessage: 'Hold',
    description: 'Hold column header'
  }
});

export const buttonText = defineMessages({
  reviewVendorsDeclinePayment: {
    defaultMessage: 'Decline Payment',
    description: 'Review vendor decline button'
  },
  reviewVendorsInvoiceSelected: {
    defaultMessage: 'Review Selected',
    description: 'Review vendor selected button'
  }
});

export const errors = defineMessages({
  invalidDueDate: {
    defaultMessage: 'Invalid Due Date',
    description: 'Error message for due date datepicker'
  },
  generalApiFailureMsg: {
    defaultMessage: 'API Fetch Failed',
    description: 'Error message for general api failure'
  },
  vendorApiFailureMsg: {
    defaultMessage:
      'Vendors have failed to load, please retry in a few moments. If issue persists, please contact CDK Support.',
    description: 'Error message for vendor api failure'
  }
});
